import React from "react";
import { Grid, TextField, Tooltip, Typography } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import { makeStyles } from "@mui/styles";
import { NumberRegex } from "../../../utils/regex";

interface InputConfigProps {
    name: string,
    label: string,
    description?: string,
    value: undefined | number,
    disabled?: boolean,
    onChange: (ConfigTypeKey: string, AssignedValue: any) => void,
    error: undefined | string,
    onError: (key: string, value: string) => void,
}

export default function InputConfig(
    {
        name,
        label,
        description,
        onChange,
        value,
        disabled,
        error,
        onError,
    }: InputConfigProps
) {
    const useStyles = makeStyles({
        inputRoot: {
            '& .MuiOutlinedInput-root': {
                width: '69px',
                height: '25px',
                textAlign: 'center',
                fontSize: 12,
                '& fieldset': {
                    borderRadius: '24px',
                    borderColor: '#F1F0F5',
                },
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: 1
                },
            }
        },
    });
    const classes = useStyles();

    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === '') {
            onChange(event.target.name, '');
            onError(event.target.name, 'This field is required.');
        } else if (NumberRegex.test(event.target.value)) {
            onChange(event.target.name, Number(event.target.value));
            onError(event.target.name, '');
        }
    }

    return (
        <Grid container sx={{ alignItems: 'center', pt: 1.5, pb: 1.5 }}>
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                {description && (
                    <Tooltip title={description} placement="right">
                        <HelpIcon sx={{ fontSize: 16, color: "#C4C4C4", cursor: "pointer", mr: '9px' }} />
                    </Tooltip>
                )}

                <Typography 
                    sx={{ 
                        fontFamily: 'Work Sans',
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '22px',
                        marginRight: '8px'
                    }}
                >
                    {label}
                </Typography>
                <TextField
                    name={name}
                    value={disabled ? `$${value ?? ''}` : value ?? ''}
                    onChange={handleTextChange}
                    classes={{
                        root: classes.inputRoot,
                    }}
                    inputProps={{ style: { textAlign: "center" } }}
                    disabled={disabled}
                    error={!!error}
                />
            </Grid>
            {error && (
                <React.Fragment>
                    <Grid item xs={12} md={4.5}></Grid>
                    <Grid item xs={12} md={7.5} sx={{ 
                        textAlign: { xs: 'center', md: 'left' }, 
                        marginTop: { xs: 0, lg: 1 }
                    }}>
                        <Typography 
                            sx={{ 
                                fontFamily: 'Work Sans',
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: '22px',
                                color: '#ff0000',
                            }}
                        >
                            {error}
                        </Typography>
                    </Grid>
                </React.Fragment>
            )}
        </Grid>
    )
}
